import { render } from "./MobileChooseButton.vue?vue&type=template&id=419c22da"
import script from "./MobileChooseButton.vue?vue&type=script&lang=js"
export * from "./MobileChooseButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__